import React from 'react';
import P from '@hero/ui-kit/typography/P';
import { MarkButton } from '../../../components/MarkControls';
import * as layout from '../../../components/markLayout.module.css';
import { getDripValidationMessage } from '../../../constants';
import type { DripValidationDestination } from '../../../constants';

type Props = {
    codes: string[];
    onNavigate: (destination: DripValidationDestination) => void;
    disabled?: boolean;
};

const DripValidationMessages: React.FC<Props> = ({ codes, onNavigate, disabled }) => (
    <div className={layout.stack}>
        {Array.from(new Set(codes.length ? codes : [null])).map((code) => {
            const { message, hint, destination } = getDripValidationMessage(code);
            return (
                <div key={code ?? 'request-error'} className={layout.field}>
                    <P noDefaultMargin styles={{ color: 'var(--mark-danger)' }}>
                        {message}
                    </P>
                    <P noDefaultMargin size="small">
                        {hint}
                    </P>
                    {destination && (
                        <MarkButton
                            onClick={() => onNavigate(destination)}
                            disabled={disabled}
                            style={{ alignSelf: 'flex-start' }}
                        >
                            {destination === 'steps'
                                ? 'Open Steps'
                                : destination === 'overview'
                                  ? 'Open Overview'
                                  : 'Open Drips list'}
                        </MarkButton>
                    )}
                    {code && /^[a-z][a-z0-9_]*$/.test(code) && (
                        <details>
                            <summary>Technical details</summary>
                            <code>{code}</code>
                        </details>
                    )}
                </div>
            );
        })}
    </div>
);

export default DripValidationMessages;
